export type ModelItem = {
    id: string;
    imageUrl: string;
    name: string;
    type: ModelItemType;
    config: string | null;
};

export enum ModelItemType {
    MAIN,
    TEMPLATES,
}

export type ModelStepsMap = { [key: string]: ModelItem[] };
